import AttributeFilters from '../attribute-filters'
import carlineFiltersContainer from './carlineFiltersContainer'

export default carlineFiltersContainer(AttributeFilters)
